import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Features from "@/components/landing/Features";
import Disciplines from "@/components/landing/Disciplines";
import AppScreenshots from "@/components/landing/AppScreenshots";
import Pricing from "@/components/landing/Pricing";
import FAQ from "@/components/landing/FAQ";
import Footer from "@/components/landing/Footer";
import PrivacyPolicy from "@/components/legal/PrivacyPolicy";
import TermsConditions from "@/components/legal/TermsConditions";

function LandingPage() {
  return (
    <>
      <Navbar />
      <Hero />
      <Features />
      <Disciplines />
      <AppScreenshots />
      <Pricing />
      <FAQ />
      <Footer />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <div className="min-h-screen bg-[#1a1f26] text-white">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/privacidad" element={<PrivacyPolicy />} />
            <Route path="/terminos" element={<TermsConditions />} />
          </Routes>
        </div>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
